import { Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import AnimatedLetters from '../AnimatedLetters/AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
import './Contact.scss'
import { contactCoords, profile } from '../../data/profileData'

function Contact() {
   const [letterClass, setLetterClass] = useState('text-animate')

   useEffect(() => {
      setTimeout(() => {
         setLetterClass('text-animate-hover')
      }, 3000)
   }, [])

   return (
     <>
       <div className="page">
         <span className="tags top-html">&lt;/html&gt;</span>
         <span className="tags top-tags">&lt;body&gt;</span>

         <div className="container contact-page">
           <div className="text-zone">
             <h1>
               <AnimatedLetters
                 letterClass={letterClass}
                 strArray={["C", "o", "n", "t", "a", "c", "t", " ", "m", "e"]}
                 idx={15}
               />
             </h1>
             <p>
               I build AI systems and backend infrastructure &mdash; focused on
               retrieval, knowledge graphs, and reliable data pipelines.
               I&apos;m open to conversations around strong engineering opportunities
               where my work and experience can add real value.
             </p>
             <div className="contact-icons">
               <a
                 href={profile.linkedin}
                 target="_blank"
                 rel="noreferrer"
                 aria-label="LinkedIn"
               >
                 <FontAwesomeIcon icon={faLinkedin} />
                 <span>LinkedIn</span>
               </a>
               <a
                 href={`mailto:${profile.email}`}
                 aria-label="Email"
               >
                 <FontAwesomeIcon icon={faEnvelope} />
                 <span>Email</span>
               </a>
               <a
                 href={profile.github}
                 target="_blank"
                 rel="noreferrer"
                 aria-label="GitHub"
               >
                 <FontAwesomeIcon icon={faGithub} />
                 <span>GitHub</span>
               </a>
             </div>
           </div>
           <div className="info-map">
             {profile.name}
             <br />
             {profile.location}
             <br />
             India <br />
             <br />
             <span>
               @:
               <span> {profile.email}</span>
             </span>
           </div>
           <div className="map-wrap">
             <MapContainer center={contactCoords} zoom={15.2}>
               <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
               <Marker position={contactCoords}>
                 <Popup>
                   Sameer studies at MIT Academy of Engineering
                 </Popup>
               </Marker>
             </MapContainer>
           </div>
           <div className="contact-links">
             <a href={profile.leetcode} target="_blank" rel="noreferrer">
               LeetCode
             </a>
             <a href={profile.linkedin} target="_blank" rel="noreferrer">
               LinkedIn
             </a>
             <a href={profile.github} target="_blank" rel="noreferrer">
               GitHub
             </a>
             <a href={profile.resume} target="_blank" rel="noreferrer">
               Resume
             </a>
           </div>
         </div>

         <Outlet />
         <span className="tags bottom-tags">
           &lt;/body&gt;
           <br />
           <span className="bottom-tag-html">&lt;/html&gt;</span>
         </span>
       </div>
     </>
   );
}

export default Contact
